module.exports = __webpack_public_path__ + "static/img/son5_active.8b8b193c.png";